import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { editHomework } from "../../../api/endpoints/HomeworkEndpoints";
import { Homework } from "../../../models/Homework";

export default function useEditHomework(homeworkId: string) {
  return useMutation<void, AxiosError, { homework: Partial<Homework> }>({
    mutationKey: ["create-or-edit-exercise", homeworkId],
    mutationFn: ({ homework }) => editHomework(homework),
  });
}
